import { OPERATOR_ROLE } from "../global/access-control";
export var DatalabCategory;
(function (DatalabCategory) {
    DatalabCategory[DatalabCategory["User"] = 1] = "User";
    DatalabCategory[DatalabCategory["System"] = 2] = "System";
    DatalabCategory[DatalabCategory["Demo"] = 4] = "Demo";
    DatalabCategory[DatalabCategory["Test"] = 8] = "Test";
    DatalabCategory[DatalabCategory["SingleInstance"] = 16] = "SingleInstance";
})(DatalabCategory || (DatalabCategory = {}));
